import { formatDate } from '@libs/dates';
import { ErrorIcon } from '@ui/icons/ErrorIcon/ErrorIcon';

import { RcfAttributes } from '@features/shared/api/typings';
import { RcfAttributesEditorModal } from '@features/user/ui/RcfAttributesEditorModal/RcfAttributesEditorModal';

import styles from './RcfAttributesControl.module.css';

type Props = {
  userName: string;
  value: RcfAttributes;
  onChange: (newValue: RcfAttributes) => void;
  isModalOpen: boolean;
  openModal: () => void;
  hideModal: () => void;
};

export function RcfAttributesControl({
  userName,
  value,
  onChange,
  isModalOpen,
  openModal,
  hideModal,
}: Props) {
  const displayedAttributes = [];
  const title = [];
  if (value.rcfId) {
    displayedAttributes.push(value.rcfId);
    title.push('ID ФШР - ' + value.rcfId);
  } else {
    if (value.gender) {
      displayedAttributes.push(GENDER_RU_SHORT[value.gender]);
      title.push('Пол - ' + GENDER_RU_FULL[value.gender]);
    }
    if (value.birthdayTimestampMs) {
      displayedAttributes.push(new Date(value.birthdayTimestampMs).getFullYear());
      title.push('День рождения - ' + formatDate(value.birthdayTimestampMs));
    }
  }

  const hasError = !value.rcfIdApproved;
  if (hasError) {
    title.push('ФШР ID не подтвержден. Нужно заполнить данные.');
  }

  return (
    <div>
      <div className={styles.status} onClick={openModal} title={title.join(', ')}>
        {hasError ? (
          <span className={styles.errorIcon}>
            <ErrorIcon />
          </span>
        ) : (
          displayedAttributes.join(' · ')
        )}
      </div>

      {isModalOpen && (
        <RcfAttributesEditorModal
          userName={userName}
          value={value}
          onChange={onChange}
          onClose={hideModal}
        />
      )}
    </div>
  );
}

const GENDER_RU_SHORT = {
  Male: 'М',
  Female: 'Ж',
};
const GENDER_RU_FULL = {
  Male: 'мужской',
  Female: 'женский',
};
